// import React, { useEffect, useState } from "react";
// import { Modal, Tabs, Form, Input, Button, Select, Card, Alert } from "antd";
// import { User, Mail, KeyRound, Crown, Shield, Building2, ClipboardList } from "lucide-react";
// import "./UserManagementModal.css"; // normal CSS file for styling
// import SubscriptionPlanTab from "./SubscriptionPlanTab";
// import MainRoleTab from "./MainRoleTab";
// import BrandsOverridesTab from "./BrandsOverridesTab";
// import SummaryTab from "./SummaryTab";
// import BasicInfoTab from "./BasicInfoTab";

// const { TabPane } = Tabs;
// const { Option } = Select;

// const UserManagementModal = ({ visible, onClose, onSave, roles = [], parentProps = {}, accessContents = [], subscriptionPlans = [], selectedUserData }) => {
//   const [userData, setUserData] = useState();
//   const [hasChanges, setHasChanges] = useState(false);
//   const [toSaveUserData, setToSaveUserData] = useState({});
//   // {
//   //     name: "",
//   //     firstname: "",
//   //     lastname: "",
//   //     email: "",
//   //     subscriptionPlan: "basic",
//   //     mainRole: "viewer",
//   //     brandOverrides: {},
//   //   }
//   useEffect(() => {
//     if (selectedUserData) {
//       setUserData(selectedUserData);
//     }
//     console.log("UserManagementModal mounted with userData: " + JSON.stringify(selectedUserData));
//   }, [selectedUserData]);

//   useEffect(() => {
//     console.log("UserManagementModal mounted with subscriptionPlans: " + JSON.stringify(subscriptionPlans));
//   }, [subscriptionPlans]);

//   useEffect(() => {
//     console.log("toSaveUserData changed: " + JSON.stringify(toSaveUserData));

//     //compater to userData only keys existing in toSaveUserData
//     if (userData) {
//       const keysToCompare = Object.keys(toSaveUserData);
//       const hasDiff = keysToCompare.some(key => {
//         if (key == 'roleids') {
//           const currentRoleIDs = userData && userData.roles ? userData.roles.map(r => r.roleid) : [];
//           return (toSaveUserData.roleids.length !== currentRoleIDs.length) || !toSaveUserData.roleids.every(rid => currentRoleIDs.includes(rid));
//         }
//         if(key == 'planid') {
//           const currentPlanID = userData && userData.plan ? userData.plan.planid : null;
//           return toSaveUserData.planid !== currentPlanID;
//         }
//         if (Array.isArray(toSaveUserData[key]) && Array.isArray(userData[key])) {
//           return JSON.stringify(toSaveUserData[key]) !== JSON.stringify(userData[key]);
//         }
//         return toSaveUserData[key] !== userData[key];
//       });
//       setHasChanges(hasDiff);
//     } else {
//       setHasChanges(false);
//     }
//   }, [toSaveUserData]);
//   // Handle input changes
//   const handleInputChange = (field, value) => {
//     setUserData({ ...userData, [field]: value });
//   };

//   const handleUserDataChange = (section, newData) => {
//     switch (section) {
//       case "info":
//         setToSaveUserData({ ...toSaveUserData, ...newData });
//         console.log("BasicInfoTab newData: " + JSON.stringify(newData));
//         break;
//       case "plan":
//         setToSaveUserData({ ...toSaveUserData, planid: newData });
//         console.log("SubscriptionPlanTab newData: " + JSON.stringify(newData));
//         break;
//       case "role":
//         setToSaveUserData({ ...toSaveUserData, roleids: newData });
//         console.log("MainRoleTab newData: " + JSON.stringify(newData));
//         break;
//       case "brand":
//         setToSaveUserData({ ...toSaveUserData, accesscontent: JSON.stringify(newData) });
//         console.log("BrandsOverridesTab newData: " + JSON.stringify(newData));
//         break;
//       default:
//         break;
//     }

//   }

//   // Handle save
//   const handleSave = () => {
//     const { requestServerPost, usertoken } = parentProps;

//     if (!userData)
//       return;

//     const params = new FormData();

//     // params.append("userid", 139);
//     // params.append("firstname", "John");
//     // params.append("lastname", "Doe");
//     // params.append("accesscontent", "[]");

//     params.append("userid", userData.userid)
//     console.log("toSaveUserData before save: " + JSON.stringify(toSaveUserData));
//     //transfer all keys in toSaveUserData to params
//     Object.keys(toSaveUserData).forEach(key => {
//       if (toSaveUserData[key] !== undefined && toSaveUserData[key] !== null) {
//         if (Array.isArray(toSaveUserData[key])) {
//           toSaveUserData[key].forEach((val) => {
//             params.append(`${key}[]`, val);
//           });
//         } else {
//           params.append(key, toSaveUserData[key]);
//         }
//       }
//     });

//     // console.log("Saving user with params: " + JSON.stringify([...params]));
//     requestServerPost("update_user", params, { }, (response) => {

//       console.log(JSON.stringify(response))
//       // resolve(newStatus)

//       if (onSave) onSave(userData);
//       onClose();
//     }, usertoken);
//   };

//   return (
//     <Modal
//       title="User Management"
//       visible={visible}
//       onCancel={onClose}
//       footer={userData ? [
//         <Button key="save" disabled={!hasChanges} type="primary" onClick={handleSave}>
//           Save
//         </Button>,
//       ] : null}
//       width={800}
//     >
//       {hasChanges && <Alert showIcon type="warning" message="You have unsaved changes" style={{ marginBottom: "6px", borderRadius: "5px" }}></Alert>}

//       <Tabs defaultActiveKey="info">
//         {/* ------------------ Basic Info Tab ------------------ */}
//         <TabPane
//           tab={
//             <span className="tab-icon-text">
//               <User size={16} /> Basic Info
//             </span>
//           }
//           key="info"
//         >
//           <BasicInfoTab userData={userData} setUserData={setUserData} onDataChange={(newData) => { handleUserDataChange("info", newData) }} />
//         </TabPane>

//         {/* ------------------ Subscription Plan Tab ------------------ */}
//         <TabPane
//           tab={
//             <span className="tab-icon-text">
//               <Crown size={16} /> Subscription Plan
//             </span>
//           }
//           key="plan"
//         >
//           <SubscriptionPlanTab userData={userData} setUserData={setUserData} subscriptionPlans={subscriptionPlans} onDataChange={(newData) => { handleUserDataChange("plan", newData) }} />
//         </TabPane>

//         {/* ------------------ Main Role Tab ------------------ */}
//         <TabPane
//           tab={
//             <span className="tab-icon-text">
//               <Shield size={16} /> Main Role
//             </span>
//           }
//           key="role"
//         >
//           <MainRoleTab userData={userData} currentUserData={toSaveUserData} roles={roles} subscriptionPlans={subscriptionPlans} setUserData={setUserData} onDataChange={(newData) => { handleUserDataChange("role", newData) }} />
//         </TabPane>

//         {/* ------------------ Brand Overrides Tab ------------------ */}
//         <TabPane
//           tab={
//             <span className="tab-icon-text">
//               <Building2 size={16} /> Brand Access
//             </span>
//           }
//           key="brand"
//         >
//           <BrandsOverridesTab userData={userData} setUserData={setUserData} accessContents={accessContents} onDataChange={(newData) => { handleUserDataChange("brand", newData) }} />
//         </TabPane>

//         {/* ------------------ Summary Tab ------------------ */}
//         <TabPane
//           tab={
//             <span className="tab-icon-text">
//               <ClipboardList size={16} /> Summary
//             </span>
//           }
//           key="summary"
//         >
//           <SummaryTab userData={userData} currentUserData={toSaveUserData} subscriptionPlans={subscriptionPlans} roles={roles} setUserData={setUserData} accessContents={accessContents} />
//         </TabPane>
//       </Tabs>
//     </Modal>
//   );
// };

// export default UserManagementModal;


import React, { useEffect, useState, useRef, useMemo } from "react";
import { Modal, Tabs, Button, Alert, message, notification, Spin } from "antd";
import { User, Crown, Shield, Building2, ClipboardList } from "lucide-react";
import "./UserManagementModal.css";
import SubscriptionPlanTab from "./SubscriptionPlanTab";
import MainRoleTab from "./MainRoleTab";
import BrandsOverridesTab from "./BrandsOverridesTab";
import SummaryTab from "./SummaryTab";
import BasicInfoTab from "./BasicInfoTab";

const { TabPane } = Tabs;

const UserManagementModal = ({
  visible,
  onClose,
  onSave,
  roles = [],
  parentProps = {},
  accessContents = [],
  subscriptionPlans = [],
  selectedUserData
}) => {
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [toSaveUserData, setToSaveUserData] = useState({});
  const [activeKey, setActiveKey] = useState("info");

  // child refs (one per tab)
  const tabRefs = {
    info: useRef(null),
    plan: useRef(null),
    role: useRef(null),
    brand: useRef(null),
    summary: useRef(null),
  };

  // for easy next/last detection
  const orderedKeys = useMemo(() => ["info", /*"plan",*/ "role", "brand", "summary"], []);

  const interactedTabs = useRef(new Set()); // to track interacted tabs

  //track the furthest tab reached when creating new user
  useEffect(() => {
    interactedTabs.current.add(activeKey);
  }, [activeKey]);

  useEffect(() => {
    if (selectedUserData) setUserData(selectedUserData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUserData]);

  useEffect(() => {
    // compare only keys present in toSaveUserData

    if (userData) {
      const keysToCompare = Object.keys(toSaveUserData);
      const hasDiff = keysToCompare.some((key) => {
        if (key === "roleids") {
          const currentRoleIDs = userData?.roles ? userData.roles.map((r) => r.roleid) : [];
          return (
            toSaveUserData.roleids.length !== currentRoleIDs.length ||
            !toSaveUserData.roleids.every((rid) => currentRoleIDs.includes(rid))
          );
        }
        if (key === "planid") {
          const currentPlanID = userData?.plan ? userData.plan.planid : null;
          return toSaveUserData.planid !== currentPlanID;
        }
        if (Array.isArray(toSaveUserData[key]) && Array.isArray(userData[key])) {
          return JSON.stringify(toSaveUserData[key]) !== JSON.stringify(userData[key]);
        }

        console.log("Comparing key " + key + ": toSaveUserData value = " + toSaveUserData[key] + ", userData value = " + userData[key]);
        return toSaveUserData[key] !== userData[key];
      });
      setHasChanges(hasDiff);
    } else {
      setHasChanges(false);
    }
  }, [toSaveUserData, userData]);

  // unify data updates from children
  const handleUserDataChange = (section, newData) => {
    switch (section) {
      case "info":
        console.log("BasicInfoTab newData: " + JSON.stringify(newData));
        setToSaveUserData((s) => ({ ...s, ...newData }));
        break;
      case "plan":
        setToSaveUserData((s) => ({ ...s, planid: newData }));
        break;
      case "role":
        setToSaveUserData((s) => ({ ...s, roleids: newData }));
        break;
      case "brand":
        setToSaveUserData((s) => ({ ...s, accesscontent: JSON.stringify(newData) }));
        break;
      default:
        break;
    }
  };

  // save
  const handleSave = () => {
    const { requestServerPost, usermaintoken } = parentProps;
    if (!userData) return;

    const params = new FormData();
    params.append("userid", userData.userid);


    console.log("handleSave toSaveUserData changed: " + JSON.stringify(toSaveUserData));

    // return 
    Object.keys(toSaveUserData).forEach((key) => {
      const val = toSaveUserData[key];
      if (val === undefined || val === null) return;

      if (Array.isArray(val)) {
        // append as array: key[]=1, key[]=2
        val.forEach((v) => params.append(`${key}[]`, v));
      } else {
        params.append(key, val);
      }
    });

    requestServerPost(
      "update_user",
      params,
      { },
      (response) => {
        // console.log("response", response);
        if (onSave) onSave(userData);
        onClose();
      },
      usermaintoken
    );
  };

  // continue/save from footer
  const onPrimaryClick = async () => {
    const currentRef = tabRefs[activeKey]?.current;
    if (!currentRef?.validate) {
      // If a tab doesn't need validation, treat as valid.
      proceedNextOrSave();
      return;
    }

    try {
      const ok = await currentRef.validate(); // child decides how errors are shown
      if (!ok) return; // child chose not to throw; it handled UI error
      proceedNextOrSave();
    } catch (err) {
      // If child throws, show friendly message
      message.error(err?.message || "Please fix validation errors.");
    }
  };

  const proceedNextOrSave = async () => {
    const idx = orderedKeys.indexOf(activeKey);
    const isLast = idx === orderedKeys.length - 1;

    if (isLast) {
      // If you also want to gather values from children now:
      // for (const k of orderedKeys) {
      //   const r = tabRefs[k]?.current;
      //   if (r?.getValues) {
      //     const partial = await r.getValues();
      //     // optionally merge into toSaveUserData or separate
      //   }
      // }
      handleSave();
    } else {
      setActiveKey(orderedKeys[idx + 1]);
    }
  };

  const createUser = (newUserData) => {
    const { requestServerPost, usermaintoken } = parentProps;

    setLoading(true);

    console.log("newUserData " + JSON.stringify(newUserData))

    const today = new Date();
    const next7Days = new Date();
    next7Days.setDate(next7Days.getDate() + 7);


    let formatted_start_date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
    let formatted_end_date = next7Days.getFullYear() + "-" + (next7Days.getMonth() + 1) + "-" + next7Days.getDate()

    requestServerPost("create_user", { ...newUserData, isguest: newUserData.isGuest ? 1 : 0, start_date: newUserData.isGuest ? formatted_start_date : undefined, end_date: newUserData.isGuest ? formatted_end_date : undefined }, { 'Content-Type': 'application/json' }, (response) => {

      setLoading(false);
      console.log(JSON.stringify(response))

      // this.setState({ modalVisible: false }, this.reloadUsers)
      if (newUserData.isGuest) {
        notification.success({
          message: `Guest user created successfully.`,
          description: `This account will automatically expire in 7 days.`,
          duration: 30
        })
      }
      else {
        notification.success({
          message: `A temporary password has been sent to ${newUserData.email}.`,
          description: `Please log in using this password and change it to your own upon first login.`,
          duration: 30
        })
      }

      onSave();
      onClose();
      // reloadTimelineSchedules();
    }, usermaintoken, {}, () => {
      //on fail

      setLoading(false);
    });
  }
  const isLastTab = activeKey === orderedKeys[orderedKeys.length - 1];

  const checkTabNeedsDisable = (key) => {
    if (selectedUserData) return false; // editing existing user, never disable
    // creating new user, disable if not yet reached this tab
    return !interactedTabs.current.has(key);
  };
  return (
    <Modal
      title="User Management"
      maskClosable={false}
      open={visible}            // AntD v5 prop. If on v4, use `visible={visible}`
      onCancel={onClose}
      width={800}
      footer={
        (!selectedUserData) ?
          null
          :
          <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>

            <div>
              <Button
                size="large"
                type="primary"
                onClick={userData ? handleSave : onPrimaryClick}
                disabled={userData ? !hasChanges : isLastTab ? !hasChanges : false}
              >
                {userData ? "Save" : isLastTab ? "Save" : "Continue"}
              </Button>
            </div>
          </div>
      }
    >
      <Spin spinning={loading} size="large">
        <div>
          {hasChanges && (
            <Alert
              showIcon
              type="warning"
              message="You have unsaved changes"
              style={{ marginBottom: 0, borderRadius: 5 }}
            />
          )}
        </div>
        <Tabs
          activeKey={activeKey}
          onChange={(changedKey) => {
            setActiveKey(changedKey);// if no selected user (new user), prevent user manually going to other tabs
          }}

        >
          <TabPane
            tab={<span className="tab-icon-text"><User size={16} /> Basic Info</span>}
            key="info"
          >
            {/* Child must expose validate() via forwardRef */}
            <BasicInfoTab
              ref={tabRefs.info}
              userData={userData}
              setUserData={setUserData}
              parentProps={parentProps}
              onDataChange={(newData) => { handleUserDataChange("info", newData) }}
              onStepComplete={() => {
                const idx = orderedKeys.indexOf("info");
                setActiveKey(orderedKeys[idx + 1]);
              }
              }
            />
          </TabPane>

          {/* <TabPane
          tab={<span className="tab-icon-text"><Crown size={16} /> Subscription Plan</span>}
          key="plan"
        >
          <SubscriptionPlanTab
            ref={tabRefs.plan}
            userData={userData}
            setUserData={setUserData}
            subscriptionPlans={subscriptionPlans}
            onDataChange={(newData) => handleUserDataChange("plan", newData)}
          />
        </TabPane> */}

          <TabPane
            tab={<span className="tab-icon-text"><Shield size={16} /> Main Role</span>}
            key="role"
            disabled={checkTabNeedsDisable("role")} // disable if creating new user and not reached this tab yet
          >
            <MainRoleTab
              ref={tabRefs.role}
              userData={userData}
              currentUserData={toSaveUserData}
              roles={roles}
              subscriptionPlans={subscriptionPlans}
              setUserData={setUserData}
              onDataChange={(newData) => handleUserDataChange("role", newData)}
              onStepComplete={() => {
                const idx = orderedKeys.indexOf("role");
                setActiveKey(orderedKeys[idx + 1]);
              }}
            />
          </TabPane>

          <TabPane
            tab={<span className="tab-icon-text"><Building2 size={16} /> Brand Access</span>}
            key="brand"
            disabled={checkTabNeedsDisable("brand")} // disable if creating new user and not reached this tab yet
          >
            <BrandsOverridesTab
              ref={tabRefs.brand}
              userData={userData}
              setUserData={setUserData}
              accessContents={accessContents}
              onDataChange={(newData) => handleUserDataChange("brand", newData)}
              onStepComplete={() => {
                const idx = orderedKeys.indexOf("brand");
                setActiveKey(orderedKeys[idx + 1]);
              }}
            />
          </TabPane>

          <TabPane
            tab={<span className="tab-icon-text"><ClipboardList size={16} /> Summary</span>}
            key="summary"
            disabled={checkTabNeedsDisable("summary")} // disable if creating new user and not reached this tab yet
          >
            {/* Compute display name for summary */}
            <SummaryTab
              ref={tabRefs.summary}
              userData={userData}
              currentUserData={toSaveUserData}
              subscriptionPlans={subscriptionPlans}
              roles={roles}
              setUserData={setUserData}
              accessContents={accessContents}
              onStepComplete={() => {
                //create user
                // message.info("Click Save to create user " + JSON.stringify(toSaveUserData));
                createUser(toSaveUserData);
              }}
            />
          </TabPane>
        </Tabs>

      </Spin>
    </Modal>
  );
};

export default UserManagementModal;
